import { Flex } from "@aircall/tractor";
import styled, { getColor } from "@xstyled/styled-components";

export const StyledFlex = styled(Flex)<{ disabled?: boolean }>`
  background-color: ${({ disabled }) =>
    disabled ? getColor("surface-disabled") : getColor("surface-default")};
  border-radius: 8px;
  border: 1px solid ${getColor("graphic-default")};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "initial")};
`;
